import { omitBy, isNil } from "lodash";

const response = (data: any) => {
  const { verdict } = data?.data?.result || {};

  return omitBy(
    { verdict: verdict?.hasUnconfirmedComponents ? false : true, error: data.error },
    isNil,
  );
};

export default response;
